import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const CoatFrame = styled.span`
    --coat-size: ${({ $size }) => `${$size}px`};

    flex: 0 0 var(--coat-size);
    width: var(--coat-size);
    height: var(--coat-size);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #eeeeee;
    border-radius: 8px;
    background: #ffffff;
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
    overflow: hidden;
`;

const CoatImage = styled.img`
    display: block;
    width: 82%;
    height: 82%;
    object-fit: contain;
`;

const CoatPlaceholder = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    background: #fafafa;
    color: #c80707;
    font-size: ${({ $size }) => `${Math.max(18, Math.round($size * 0.42))}px`};
    font-weight: 800;
    line-height: 1;
`;

const CityIdentityWrap = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    max-width: 100%;
    min-width: 0;
    vertical-align: middle;
`;

const CityNameText = styled.span`
    min-width: 0;
    color: inherit;
    font: inherit;
    line-height: inherit;
    overflow-wrap: anywhere;
`;

export const CityCoatOfArms = ({ city, name = city?.obec, size = 52, className }) => {
    const src = city?.coatOfArms;
    const [imageFailed, setImageFailed] = useState(false);

    useEffect(() => {
        setImageFailed(false);
    }, [src]);

    return (
        <CoatFrame className={className} $size={size} title={src && !imageFailed ? `Erb obce ${name}` : undefined}>
            {src && !imageFailed ? (
                <CoatImage src={src} alt={`Erb obce ${name}`} loading="lazy" onError={() => setImageFailed(true)} />
            ) : (
                <CoatPlaceholder $size={size} aria-label={`Erb obce ${name} není dostupný`}>
                    ?
                </CoatPlaceholder>
            )}
        </CoatFrame>
    );
};

export const CityNameWithCoatOfArms = ({ city, name = city?.obec, size = 52, className }) => (
    <CityIdentityWrap className={className}>
        <CityCoatOfArms city={city} name={name} size={size} />
        <CityNameText>{name}</CityNameText>
    </CityIdentityWrap>
);
